import { API_BASE as API, cachedFetch } from "./api";

// Category tree is DB-backed (backend/app/models.py Category) — see
// CLAUDE.md "Category Taxonomy & Product Facet Filters". includeHidden=true
// pulls in non-launch_active subcategories too (admin tools, direct deep
// links); the public nav/storefront should always call with the default.
export const fetchCategoryTree = (includeHidden = false) =>
  cachedFetch(`${API}/categories/tree${includeHidden ? "?include_hidden=true" : ""}`);

export const fetchCategory = (slug, includeHidden = false) =>
  cachedFetch(`${API}/categories/${slug}${includeHidden ? "?include_hidden=true" : ""}`);
